import { LuBuilding, LuMapPin } from "react-icons/lu";

interface BodyProps {
  item: any;
}

const Body: React.FC<BodyProps> = ({ item }) => {
  return (
    <div className="py-2 px-4 text-primary bg-white flex flex-col gap-1 justify-center items-start">
      <p className="text-lg font-semibold">{item.projectTitle}</p>
      <p className="text-sm font-normal">
        Starting At :{" $"}
        {item.price ? item.price.toLocaleString() : "0"}
      </p>
      <p className="flex items-center gap-2 text-sm font-normal">
        <LuMapPin className="text-base" />
        {item.city}
      </p>
      <p className="flex items-center gap-2 text-sm font-normal">
        <LuBuilding className="text-base" />
        {item.developer}
      </p>
    </div>
  );
};

export default Body;
